module.exports = "https://static.energy5.com/_next/static/images/facebook-6968f8d18c08e72192bd8245a303ccfe.png";